import client from './client'
import { api } from './client'

const documentService = {
  getDocuments: async ({ limit = 200, offset = 0, searchTerm, category } = {}) => {
    const params = { limit, offset }
    if (searchTerm) params.q = searchTerm
    if (category) params.category = category
    const resp = await api.get('/documents', params)
    return { documents: resp.data, total: resp.meta.total }
  },

  getDocument: async (docId) => {
    const resp = await api.get(`/documents/${docId}`)
    return resp.data
  },

  getSummary: async (docId) => {
    const resp = await api.post(`/documents/${docId}/summary`)
    return resp.data.summary
  },

  /** Fetch file as blob URL (authenticated) — for embed/img/download */
  getFileBlobUrl: async (docId, filename) => {
    const params = filename ? { name: filename } : {}
    const resp = await client.get(`/documents/${docId}/file`, { responseType: 'blob', params })
    return URL.createObjectURL(resp.data)
  },

  /** Upload a document file to R2 */
  uploadDocument: async (file, { category, description, matterId } = {}) => {
    const formData = new FormData()
    formData.append('file', file)
    if (category) formData.append('category', category)
    if (description) formData.append('description', description)
    if (matterId) formData.append('matterId', matterId)
    const resp = await api.postFormData('/documents/upload', formData)
    return resp.data
  },

  /** Trigger bulk sync of document files to R2 */
  syncFiles: async ({ limit = 50 } = {}) => {
    const resp = await api.post(`/documents/sync?limit=${limit}`)
    return resp.data
  },
}

export default documentService
